export default __webpack_public_path__ + "static/figure1-945a12ca03127e744034f1333e7a3a6e.webp";